import api from "./api";
import jwtDecode from "jwt-decode";
import { SessionAuthorizer } from "../types/session";

export const signInService = async (
  code: string
): Promise<SessionAuthorizer> => {
  const response = await api.post("signIn", { code });

  const { token, refreshToken, layoutConfig } = response.data.content;

  const parsedToken: any = jwtDecode(token);

  api.defaults.headers.common.authorization = `${token}`;

  return {
    midia: {
      id: parsedToken?.id,
      code: parsedToken?.code,
      name: parsedToken?.name,
      newsDurationSeconds: parsedToken?.newsDurationSeconds,
      hasNews: parsedToken?.hasNews,
      companyId: parsedToken?.companyId,
      hasTicketNumber: parsedToken?.hasTicketNumber,
      hasClock: parsedToken?.hasClock,
      hideHeader: parsedToken?.hideHeader,
      radioShortId: parsedToken?.radioShortId ?? null,
      // layoutConfig vem no corpo (não no JWT). null => legado.
      layoutConfig: layoutConfig ?? null,
    },
    token,
    refreshToken,
  };
};

export const refreshSession = async (
  _refreshToken: string
): Promise<SessionAuthorizer> => {
  const response = await api.post(
    "refreshToken",
    {},
    {
      headers: { "x-refresh-token": _refreshToken },
    }
  );

  const { token, refreshToken, layoutConfig } = response.data.content;

  const parsedToken: any = jwtDecode(token);

  api.defaults.headers.common.authorization = `${token}`;

  return {
    midia: {
      id: parsedToken?.id,
      code: parsedToken?.code,
      name: parsedToken?.name,
      newsDurationSeconds: parsedToken?.newsDurationSeconds,
      hasNews: parsedToken?.hasNews,
      companyId: parsedToken?.companyId,
      hasTicketNumber: parsedToken?.hasTicketNumber,
      hasClock: parsedToken?.hasClock,
      hideHeader: parsedToken?.hideHeader,
      radioShortId: parsedToken?.radioShortId ?? null,
      layoutConfig: layoutConfig ?? null,
    },
    token,
    refreshToken,
  };
};
